import { attachProfile } from "./attachProfile";
import { attachProfileUsingToken } from "./attachProfileUsingToken";
import { attachProfileWithConnectEmail } from "./attachProfileWithConnectEmail";
import { createProfile } from "./createProfile";
import { createProfileParameterSuggestion } from "./createProfileParameterSuggestion";
import { detachProfile } from "./detachProfile";
import { getConcernNames } from "./getConcernNames";
import { getCvPortalCandidateTokenForCurrentUser } from "./getCvPortalCandidateTokenForCurrentUser";
import { getUserOverviews } from "./getUserOverviews";
import { login } from "./login";
import { me } from "./me";
import { myProfiles } from "./myProfiles";
import { myProfilesWithData } from "./myProfilesWithData";
import { quickApplyConnect } from "./quickApplyConnect";
import { saveLocaleChoice } from "./saveLocaleChoice";
import { sendAttachProfileEmail } from "./sendAttachProfileEmail";
import { whoAmI } from "./whoAmI";

export const authAPI = {
  getCvPortalCandidateTokenForCurrentUser,
  login,
  whoAmI,
  me,
  myProfilesWithData,
  attachProfile,
  attachProfileUsingToken,
  sendAttachProfileEmail,
  createProfile,
  createProfileParameterSuggestion,
  myProfiles,
  detachProfile,
  saveLocaleChoice,
  getConcernNames,
  quickApplyConnect,
  getUserOverviews,
  attachProfileWithConnectEmail,
};

export type AuthAPI = typeof authAPI;
